module.exports = __webpack_public_path__ + "media/images/home/cover-mobile-6093b7d98d07c0d1240cf198bcc32c77.jpg";